<div
  [ngClass]="{
    selected: task.isHighlighted,
    'wctp-accepted': task.isWctpAccepted === true,
  }"
  class="task-item card mb-3 py-2"
  #taskItem
>
  <div class="card-title">
    <span>{{ task.data.title }}</span>
  </div>
  <div style="border-bottom: 1px solid #8cace0; margin-bottom: 8px"></div>
  <div class="px-3">
    @if (task.data.requester) {
      <div class="titleAndData">
        <div class="label">{{ "front.task-item.requester" | translate }}</div>
        <div class="data">{{ task.data.requester.name }}</div>
      </div>
    }
    <div class="titleAndData">
      <div class="label">{{ "front.task-item.time" | translate }}</div>
      <div class="data">
        {{ task.data.startTime | customFullDate }}
      </div>
    </div>
    <div class="titleAndData">
      <div class="label">{{ "front.task-item.location" | translate }}</div>
      <div class="data">
        {{ task.data.location | extractNameFromLocation }}
      </div>
    </div>
    @if (task.data.patient && !isWlmhEnabled) {
      <div class="titleAndData">
        <div class="label">{{ "front.task-item.patient" | translate }}</div>
        <div class="data">{{ task.data.patient.name ?? "John Doe" }}</div>
      </div>
    }
    @if (!isWlmhEnabled) {
      <div class="titleAndData">
        <div class="label">{{ "front.task-item.accepted_by" | translate }}</div>
        <div class="data">
          {{
            task.activeResponder?.name ?? "front.task-item.pending" | translate
          }}
        </div>
      </div>
    }
    <div class="titleAndData">
      <div class="label">{{ "front.task-item.description" | translate }}</div>
      <div class="data">
        {{
          task.type === "portering"
            ? task.data.description
            : task.data.description && task.data.additionalDetails
              ? task.data.description + ": " + task.data.additionalDetails
              : task.data.description ||
                task.data.additionalDetails ||
                "-----------"
        }}
      </div>
    </div>
    @if (isWlmhEnabled) {
      <div class="titleAndData">
        <div class="label">{{ "front.task-item.status" | translate }}</div>
        @if (task.data.escalationLevel) {
          <div class="data">
            {{ task.data.escalationLevel + " / " + task.status }}
          </div>
        } @else {
          <div class="data">
            {{ task.status }}
          </div>
        }
      </div>
    }

    @if (task.status === taskStatus.UA_CLOSED && !isWlmhEnabled) {
      <div class="titleAndData">
        <div class="label">{{ "front.task-item.closed_by" | translate }}</div>
        <div class="data">
          {{ "front.task-item.unit-administrator" | translate }}
        </div>
      </div>
    }
    @if (task.data.closeTs) {
      <div class="titleAndData">
        <div class="label">{{ "front.task-item.close-time" | translate }}</div>
        <div class="data">
          {{ task.data.closeTs | customFullDate }}
        </div>
      </div>
    }
  </div>

  @if (
    (task.status === taskStatus.ACTIVE ||
      task.status === taskStatus.INITIATED ||
      task.status === taskStatus.ESCALATED ||
      task.status === taskStatus.NOTIFY) &&
    !task.activeResponder?.id &&
    task.isTask
  ) {
    <button class="submit-btn" (click)="openCloseTaskDialog($event)">
      {{ "front.cancel-btn.close" | translate | uppercase }}
    </button>
  }
</div>
